import { createContext, useContext, useState, useMemo, useEffect } from "react";
import { onTokenChange } from "../services/apiFetch";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [tokenState, setTokenState] = useState(() => {
    try {
      return localStorage.getItem("token") || null;
    } catch {
      return null;
    }
  });

  const [stampTomadorState, setStampTomadorState] = useState(null);

  const [parentMessageState, setParentMessageState] = useState(null);
  const [parentMessageVersion, setParentMessageVersion] = useState(0);

  
  useEffect(() => {
    const unsubscribe = onTokenChange((newToken) => {
      setTokenState(newToken);
    });

    return unsubscribe;
  }, []);

  const setToken = (value) => {
    try {
      if (value) {
        localStorage.setItem("token", value);
      } else {
        localStorage.removeItem("token");
      }
    } catch (e) {
      console.error("[AuthContext] Erro ao salvar token:", e);
    }
    setTokenState(value);
  };

  const setStampTomador = (value) => {
    setStampTomadorState(value);
  };

  const setParentMessage = (value) => {
    setParentMessageState(value);
    setParentMessageVersion((version) => version + 1);
  };

  const value = useMemo(() => ({
    token: tokenState,
    setToken,
    stampTomador: stampTomadorState,
    setStampTomador,
    parentMessage: parentMessageState,
    setParentMessage,
    parentMessageVersion,
  }), [tokenState, stampTomadorState, parentMessageState, parentMessageVersion]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de AuthProvider");
  }
  return context;
};